import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().optional(),
  VITE_TEST_TOKEN: z.string().optional(),
});

const env = (() => {
  const parsed = envSchema.parse(import.meta.env);

  // Provide default values for required environment variables
  return {
    ...parsed,
    VITE_API_URL: parsed.VITE_API_URL,
    VITE_TEST_TOKEN: parsed.VITE_TEST_TOKEN,
  };
})();

export { env };
